export const messagesUsers = {
    pt: {
        message:{
            accountName: "Nome da Conta",
            becomeMaster: "Tornar Master",
            deleteUser: "Deletar Usuário",
            deleteUserConfirmation: "Quer mesmo deletar este usuário? Esta ação é irreversível",
            editUser: "Editar Usuário",
            linkSpots: "Vincular Locais",
            makeUserMaster: "Tornar Usuário Master",
            makeUserMasterConfirmation: "Quer mesmo tornar este usuário Master?",
            newUser: "Novo usuário",
            passwordResetLink: "Link de redefinição de senha",
            permissionsRestrictToMaster: "Esta permissão é restrita ao usuário master",
            registerNewUser: "Cadastrar Novo Usuário",
            resendWelcomeEmail: "Reenviar e-mail de boas vindas",
            revokePermission: "Revogar Permissão",
            revokePermissionConfirmation: "Quer mesmo revogar esta permissão? Todos os usuário filhos tambem perderão essa permissão.",
            unblock: "Desbloquear",
            unblockUser: "Desbloquear usuário",
            unlinkSpot: "Desvincular Local?",
            unlinkSpotHint: "Todos os usuários filhos que possuem este local ativo tambem serão desvinculados. Tem certeza que deseja desvincular este local do usuário?",
            viewClientsData: "Visualizar dados de clientes"
        }
    },
    es: {
        message:{
            accountName:"Nombre de la cuenta",
            becomeMaster:"Make Master",
            deleteUser:"Borrar usuario",
            deleteUserConfirmation:"¿Realmente quieres eliminar a este usuario? Esta acción es irreversible",
            editUser:"Editar usuario",
            linkSpots:"Links Locales",
            makeUserMaster:"Crear usuario maestro",
            makeUserMasterConfirmation:"¿Realmente quieres hacer que este usuario sea maestro?",
            newUser:"Nuevo Usuario",
            passwordResetLink:"Enlace de redefinición de contraseña",
            permissionsRestrictToMaster: "Este permiso está restringido al usuario maestro.",
            registerNewUser:"Registre un nuevo usuario",
            resendWelcomeEmail:"Reenvíe el correo electrónico de bienvenida",
            revokePermission:"Revocar permiso",
            revokePermissionConfirmation:"¿Realmente quieres revocar este permiso? Todos los niños también perderán este permiso",
            unblock:"Desbloquear",
            unblockUser:"Desbloqueo de usuario",
            unlinkSpot:"¿Separar el lugar?",
            unlinkSpotHint:"Todos los usuarios que tienen este lugar activo también se separarán. ¿Estás seguro de que quieres separar esta ubicación del usuario?",
            viewClientsData: "Ver datos del cliente"
        }
    },
    en: {
        message:{
            accountName: "Account name",
            becomeMaster: "Become Master",
            deleteUser: "Delete User",
            deleteUserConfirmation: "Do you really want to delete this user? This action is irreversible",
            editUser: "Edit User",
            linkSpots: "Link Spots",
            makeUserMaster: "Make this user Master",
            makeUserMasterConfirmation: "Do you really want to make this user Master?",
            newUser: "New user",
            passwordResetLink: "Password reset link",
            permissionsRestrictToMaster: "This permission is restricted to the master user",
            registerNewUser: "Register New User",
            resendWelcomeEmail: "Resend welcome email",
            revokePermission: "Revoke permission",
            revokePermissionConfirmation: "Do you really want to revoke this permission? All child users will also lose this permission.",
            unblock: "Unblock",
            unblockUser: "Unblock user",
            unlinkSpot: "Unlink Spot?",
            unlinkSpotHint: "All child users who have this location active will also be unlinked. Are you sure you want to unlink this user spot?",
            viewClientsData: "View clients data"



        }
    }
}
